module.exports = __webpack_public_path__ + "seat.png";